import { Component } from '@angular/core';
import { Maps, MapsTooltip, ISelectionEventArgs, Selection, Highlight, MapsModule, MapsTooltipService, DataLabelService } from '@syncfusion/ej2-angular-maps';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { italyMap } from '../../../../../../shared/italy-regions';
import { NtPotentialRegionInterface } from '../../../../../../shared/interfaces/nt-potential-region.interface';
import { ModalPotPerRegHospitalsComponent } from '../modal-pot-per-reg-hospitals/modal-pot-per-reg-hospitals.component';
import { CommonModule } from '@angular/common';

Maps.Inject(MapsTooltip, Selection, Highlight);

@Component({
  selector: 'app-potential-per-region-map',
  imports: [MapsModule, ModalPotPerRegHospitalsComponent, CommonModule],
  providers: [MapsTooltipService, DataLabelService],
  templateUrl: './potential-per-region-map.component.html',
  styleUrl: './potential-per-region-map.component.css'
})
export class PotentialPerRegionMapComponent {


  public mapWidth: string = '98%';
  public mapHeight: string = '98%';
  public layers?: object[];
  public medicineId = 0;
  public countryId = 1;

  regionId = 0;
  regionName = '';

  regionPercentage = '0';
  regionsData: NtPotentialRegionInterface[] = [];

  isActiveModalHospital = false;

  // totale esperienze a livello nazionale
  experienceTotal = 0;

  constructor (private dataService: DataService) { }

  ngOnInit (): void {
  this.layers = [
    {
      shapeData: italyMap

    }
  ];

    this.medicineId = sessionStorage.getItem('medicineId') ? Number(sessionStorage.getItem('medicineId')) : 0;
    this.countryId = sessionStorage.getItem('countryId') ? Number(sessionStorage.getItem('countryId')) : 1;
    this.loadData();
    this.getNationalExperienceAndHospitalInfo();
    /*
    this.dataService.medicineUpdated$.subscribe((medicineId: number) => {
      if (medicineId !== 0) {
        this.medicineId = medicineId;
        this.loadData();  
      }
    });
*/
  }

  loadData () {
    this.dataService.getRegioniData(this.medicineId, this.countryId).subscribe((data: NtPotentialRegionInterface[]) => {

      if (data && data.length > 0) {
      //  console.log('data', data);

        const regioniData = data.map(item => {
          if (item.percentage !== undefined) {
            item.percentage = parseFloat(item.percentage).toFixed(2);
          }


          
          /*if (Number(item.regionId) === 4) {
            // Find additional data for id5 and combine the tooltip text
            const region5 = data.find(i => Number(i.regionId) === 5);
            if (region5) {
              return {
                ...item,
                tooltipText: `${item.regionName}: ${item.percentage}%<br>${region5.regionName}: ${region5.percentage}%`
              };
            }
          }*/
          // Default tooltip text for other regions
        return {
  ...item,
  tooltipText: `${
    item.regionName === 'Prov. Aut. di Bolzano' ? 'PA di Bolzano' :
    item.regionName === 'Prov. Aut. di Trento' ? 'PA di Trento' :
    item.regionName
  }: <br>${item.percentage}%`
};

        });
        
        this.regionsData = regioniData;

        this.layers = [
          {
            shapeData: italyMap,
            shapePropertyPath: 'id',
            shapeDataPath: 'regionId',
            dataSource: regioniData,
            tooltipSettings: {
              visible: true,
              valuePath: 'tooltipText',
              //format: '${regionName}: <br>${percentage}%'
              textStyle: {
                size: '10px',
              },
            },
         highlightSettings: {
  enable: false,
},
selectionSettings: {
  enable: false,
  fill: '#FFFFFF',
  border: {
    color: '#162456',
    width: 1,
  },
  opacity: 1,
},

            shapeSettings: {
              //fill: '#088a95',
              //fill: '#088091',

              fill: '#FFFFFF',
              colorValuePath: '#DDE1E5',
                border: {
        color: '#162456',
        width: 0.7,
      },
            },
          },
        ];
      }
    });
  }

  public itemSelection = (args: ISelectionEventArgs) => {
 //   console.log('data', args.data);
    if (args.shapeData !== isNullOrUndefined) {
      this.showModalHospitals(!this.isActiveModalHospital);
      this.regionId = Number((args.data as NtPotentialRegionInterface).regionId)
      this.regionName = (args.data as NtPotentialRegionInterface).regionName
      this.regionPercentage = (args.data as NtPotentialRegionInterface).percentage ?? '0'
    }
  };

  showModalHospitals (value: boolean) {
    this.isActiveModalHospital = value

    if (this.isActiveModalHospital) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

public mapClick = (args: any) => {
  
  if (args.shapeData && args.shapeData.id) {
    this.regionId = Number(args.shapeData.id);
    
    this.regionName = args.shapeData.properties?.name ||
                     args.shapeData.properties?.regionName ||
                     args.shapeData.regionName ||
                     args.data?.regionName ||
                     'Regione';

    this.regionPercentage = args.data?.percentage ||
                     this.regionsData.find(r => Number(r.regionId) === this.regionId)?.percentage ||
                     '0';

    this.showModalHospitals(true);
  }
};

getNationalExperienceAndHospitalInfo() {
  this.dataService
    .getNationalExperienceAndHospitalInfo(this.medicineId, this.countryId)
    .subscribe({
      next: (data) => {
     // we can simulate empty data with
        //  data=[]
        this.experienceTotal = data?.experienceTotal ?? 0;
      },
      error: () => {
        this.experienceTotal = 0;
      }
    });
}

}